module.exports = {

  "pleaseWait": "කරුණාකර අපේක්ෂා කරන්න",
  "loading": "පූරණය වෙමින්",
  "Billing": "ගෙවීම්",
  "billingTips": "ඔබගේ මිලදී ගැනීම් ඉතිහාසය",
  "ID": "හැඳුනුම්පත් අංකය",
  "FAQ": "සාමාන්‍ය ප්‍රශ්න",
  "TC": "ප්‍රතිපාදන සහ කොන්දේසි",
  "Copyright": "© 2026 සියලු හිමිකම් ඇවිරිණි.",
  "GenerateImage": "පින්තූර ජනනය කරන්න",
  "generateTips1": "අපගේ AI පින්තූර ජනකය ඔබේ සිතුවිලි ජීවිතයට ගෙන එයි, සුන්දර කලා, චිත්‍ර, සහ ඡායාරූප තත්පර කිහිපයකින්ම නිර්මාණය කරයි. AI බලයෙන් නිර්මාණශීලීත්වය නිදහස් කරගන්න. අසීමිත හැකියාවන් විමසුම, අලෙවිකරණ ද්‍රව්‍ය නිර්මාණය කිරීමෙන් සොඳුරු කලා නිර්මාණය දක්වා පහසුවෙන් සිදු කරන්න.",
  "generateTips2": "පහත කිහිප වචන ඇතුළත් කරන්න, Snapai එක අසහාය කලා නිර්මාණයට පෙරළන බව බලන්න.",
  "Prompt": "ප්‍රොම්ප්ට්",
  "PromptTips1": "AIට චිත්‍ර අඳින්න කියන්න",
  "PromptTips2": "උපදෙස්: මනෝභාවය සහ ආලෝකය විස්තර කරන්න. වැඩි උපදෙස් සඳහා පිටුව බලන්න.",
  "PromptTips3": "සටහන: AI උපදෙස් අනුව ක්‍රියා නොකරනු ඇත සහ ගණනය කිරීමට නොහැක.",
  "Generate": "ජනනය කරන්න",
  "ChancesLeft": "ඉතිරි අවස්ථා",
  "BuyChances": "වැඩි අවස්ථා මිලදී ගන්න",
  "generateImageTips1": "ඔබට අවශ්‍ය දෙය ඇතුළත් කරන්න",
  "generatePromptsTips1": "ඔබට අවශ්‍ය නැති දෙය ඇතුළත් කරන්න",
  "indexTips1": "දෛනික නොමිලේ අවස්ථාව <br /> ලබා ගත හැක!",
  "indexTips2": "මෙම දේවල් වලින් එකක් තෝරන්න",
  "ImageRestorer": "පින්තූර යළි සකසන්න",
  "Continue": "ඉදිරියට යන්න",
  "language0": "භාෂාව",
  "language": "භාෂාව තෝරන්න",
  "languageTips": "ඔබේ භාෂාව මෙහි තෝරන්න",
  "Submit": "ඉදිරිපත් කරන්න",
  "change": "වෙනස් කරන්න",
  "English": "ඉංග්‍රීසි",
  "Myanmar": "සිංහල",
  "Login": "ඇතුල් වන්න",
  "Logout": "පිටවීම",
  "getCode": "නැවත යවන්න",
  "loginTips": "දුරකථන අංකයක් ඇතුළත් කරන්න",
  "profile": "පැතිකඩ",
  "phoneNumber": "දුරකථන අංකය",
  "SubscribedSince": "චන්දාව ගත් දිනය",
  "RemainingChances": "ඉතිරි අවස්ථා",
  "cgtips2": "දෛනිකව 149 Ks පමණයි,<br />චන්දාව ගන්න OK ක්ලික් කරන්න.",
  "cgtips2W": "සතිපතා 599 Ks පමණයි,<br />චන්දාව ගන්න OK ක්ලික් කරන්න.",
  "cgtips2M": "මාසිකව 1999 Ks පමණයි,<br />චන්දාව ගන්න OK ක්ලික් කරන්න.",
  "OK": "ඔකේ",
  "PictureRestorer": "පින්තූර යළි සකසන්න",
  "PictureTips1": "AI සමඟ පින්තූර යළි සකසන්න, තීව්‍ර කරන්න, සහ නඩත්තු කරන්න. Snapai අලුත්ම පර්යේෂණ මත පදනම්ව ස්වයංක්‍රීයව කැස්සුම් ඉවත් කරයි, වර්ණ තීව්‍ර කරයි, මුහුණු වැඩි දියුණු කරයි, හා විනාශ වූ ඡායාරූප සුරැකි මතකයන් බවට පරිවර්තනය කරයි. අපගේ නොමිලේ සේවාව වර්ණ සහ කළු & සුදු ඡායාරූප දෙකම සකසයි.",
  "Upload": "ඡායාරූප උඩුගත කරන්න",
  "PictureTips2": "කැස්සුම් තිබේද?",
  "Restore": "යළි සකසන්න",
  "uploadTips": "කරුණාකර පින්තූර උඩුගත කරන්න",
  "PurchaseChances": "අවස්ථා මිලදී ගන්න",
  "History": "ඉතිහාසය",
  "purchaseTips1": "ඔබගේ සමස්ත අවස්ථා",
  "purchaseTips2": "එකවර මිලදී ගැනීම",
  "Daily": "දෛනික",
  "Weekly": "සතිපතා",
  "OneTime": "එක් වතාවක්",
  "Purchase": "මිලදී ගන්න",
  "DailyKyats": "169 Ks",
  "WeeklyKyats": "699 Ks",
  "OneTimeChance": "149 Ks/අවස්ථාව",
  "Subscribe": "චන්දාව ගන්න",
  "purchaseTips3": "කරුණාකර කොපමණ <strong>අවස්ථා</strong> මිලදී ගැනීමට තෝරන්න.",
  "BuyNow": "දැන් මිලදී ගන්න",
  "logout": "පිටවීම",
  "petTitle1": "AI සතුන් Anime",
  "petTitle2": "ශෛලිය තෝරන්න",
  "petContent1": "ඔබේ ප්‍රියතම සතෙකුගේ ඡායාරූප අමුතු anime-ශෛලියේ කලා නිර්මාණයකට පරිවර්තනය කරයි. සතුන් ආදරකරුවන්ට සහ anime රසිකයන්ට සුදුසු, Snapai ඔබේ සතෙකු සමඟ සතුට සහ පෞද්ගලික අත්දැකීමක් ලබා දෙයි.",
  "sexTitle1": "AI පෞද්ගලික Anime",
  "sexTitle2": "ස්ත්‍රී/පුරුෂ තෝරන්න",
  "sexContent1": "ලියන ලද ප්‍රොම්ප්ට් මත පදනම්ව anime-ශෛලියේ ඡායාරූප ජනනය කිරීමෙන් ඔබේ සිතුවිලි ජීවිතයට ගෙන එයි. Anime රසිකයෙක්, කතාකරු, හෝ නිර්මාණකරු වුවද, AI Anime ඡායාරූපය සරලව උසස්-තත්ත්ව anime දර්ශන නිර්මාණය කිරීමට හැකියාව සපයයි.",
  "sexContent2": "පහත ස්ත්‍රී/පුරුෂ තෝරන්න සහ ප්‍රොම්ප්ට් ඇතුළත් කරන්න. Snapai පෙළ අසහාය කලා බවට පෙරළයි බලන්න.",
  "Female": "ස්ත්‍රී",
  "Male": "පුරුෂ",
  "Style1": "ශෛලිය 1",
  "Style2": "ශෛලිය 2",
  "Style3": "ශෛලිය 3",
  "Comic": "කොමික්",
  "Disney": "ඩිස්නි",
  "Ghibli": "ඝිබ්ලි",
  "Animalanime": "ස්වයංඡායාරූප Anime",
  "HumanAnime": "මිනිසා Anime",
  "Guidance": "මාර්ගෝපදේශය",
  "PetAnime": "සතුන් Anime",
  "landTips1": "සුන්දර ඡායාරූප ජනනය කරන්න &",
  "landTips2": "ලොකු සම්මාන දිනාගන්න!",
  "landTips3": "SnapAI සමඟ ඔබේ සිතුවිලි සැබෑ කරවන්න! සුන්දර ඡායාරූප ජනනය කිරීමෙන් කලාව නිර්මාණය දක්වා, SnapAI ඔබට පෙර නොවූ පරිදි දර්ශන නිර්මාණය කිරීමට බලය සපයයි. අසීමිත හැකියාවන් ඇති ලෝකයකට පිවිසෙන්න.",
  "show401tip": "බැලන්ස් නොමැත",
  "show400dailytip": "වේලාව අවසන්, ලොකු සම්මානය දිනා ගැනීමට 'ON1' 548 ට යවන්න.",
  "show400weeklytip": "වේලාව අවසන්, ලොකු සම්මානය දිනා ගැනීමට 'ON7' 548 ට යවන්න.",
  "register": "ලියාපදිංචි වන්න",
  "invitation": "ආරාධනය",
  "invitationTips": "පහත සබැඳිය භාවිතා කර ආරාධනය පිටපත් කර යවන්න",
  "InviteNow": "දැන් ආරාධනය කරන්න",
  "copySuccess": "පිටපත් කිරීම සාර්ථකයි!",
  "process": "ජනනය වෙමින්",
  "downTips1": "කරුණාකර සබැඳිය බ්‍රවුසරයට පිටපත් කර බාගන්න.",
  "copyLink": "සබැඳිය පිටපත් කරන්න",
  "free": "නොමිලේ",
  "aiAnimeTitle": "AI යුවල Anime",
  "aiAnimeCt1": "ඔබේ මුල් යුවල ඡායාරූප anime-ශෛලියේ රූප බවට පරිවර්තනය කර, ඔබේ රෝමාන්තික මතක තවත් රසවත් කරයි. Anime රසිකයෙක් හෝ නිර්මාණකරු වුවද, AI Anime ඡායාරූපය උසස්-තත්ත්ව anime දර්ශන නිර්මාණය කිරීමට පහසුම ක්‍රමය සපයයි.",
  "aiAnimeCt2": "පහත ශෛලිය තෝරන්න සහ ඔබේ මුල් ඡායාරූප උඩුගත කරන්න. Snapai ඔබේ රසවත් මතකයන් සුන්දර කලා නිර්මාණ බවට පෙරළයි.",
  "comingsoonT": "ඉක්මනින් එනවා",
  "SubscribePackage": "චන්දාව පැකේජය",
  "landfont1": "ඡායාරූපය සුන්දර anime කලා නිර්මාණයකට පරිවර්තනය කරන්න.",
  "landfont2": "ඔබේ යුවල ඡායාරූප සුන්දර anime චරිතවලට පරිවර්තනය කරන්න.",
  "landfont3": "සුන්දර රූප ජනනය කිරීමට ප්‍රොම්ප්ට් ලියන්න",
  "landfont4": "ඔබේ සතුන් AI මායාවෙන් අලංකාර anime චරිතවලට පරිවර්තනය කරන්න!",
  "landfont5": "AI බලයෙන් පින්තූර යළි සකසා ඔබේ මතක නැවත සොයා බලන්න.",
  "SmartCutout": "ස්මාර්ට් කට්අවුට්",
  "letgo": "එන්න",
  "IpIMage": "හැඳුනුම්පත් ඡායාරූපය",
  "IpIMageTip": "අනුමත ඡායාරූප හෝ ID ඡායාරූප අවශ්‍යද? අපි සූදානම්!",
  "IpIMage_content": "ID ඡායාරූප සඳහා උඩුගත කළ මුල් ඡායාරූපයේ පුද්ගලයාගේ මුහුණ පැහැදිලිව සහ වළඳා නොමැතිව, උරහිස් සමාන ලෙස සැකසිය යුතුය. නැතහොත් ජනනය අසාර්ථක විය හැක.",
  "snapbot": "SnapBot",
  "snapbot_hi": "හයි, මම SnapBot.",
  "help_today": "අද මම ඔබට කෙසේ උදව් කළ හැකිද?",
  "think_ip": "🤖 සිතමින්...",
  "Coloring_old_photos": "පින්තූර වර්ණය",
  "Coloring_old_photos_tips": "ඔබේ මතක නැවත ජීවත් කරන්න, පරණ ඡායාරූපවල වර්ණ යළි සකසා.\nඅපගේ AI මෙවලම ස්වයංක්‍රීයව විශ්ලේෂණය කර ස්වභාවික වර්ණ ලබා දෙයි,\nමුල් ආකර්ෂණය රැක ගැනීමත් සමඟ දෘශ්‍ය ආකර්ෂණය වැඩි දියුණු කරයි.",
  "Coloring_old_photos_tips2": "AI බලයෙන් පරණ ඡායාරූප නැවත ජීවිතයට පත් කරන්න.",
  "BgFusion": "ස්මාර්ට් මිශ්‍රණය",
  "BgFusion_tips2": "ඔබ කැමති පසුබැසිය සමඟ ඡායාරූප අභිරුචි කරන්න",
  "BgFusion_tips": "ඔබ කැමති පසුබැසිය සමඟ ඡායාරූප අභිරුචි කරන්න.\nඅපගේ ස්මාර්ට් AI මුල් පසුබැසිය ප්‍රතිස්ථාපනය කර\nඔබේ රූපය නව දෘශ්‍යයට ස්වාභාවිකව මිශ්‍ර කරයි.",
  "Upload_bg": "පසුබැසිය උඩුගත කරන්න",
  "Upload_pt": "පෝට්‍රෙට් උඩුගත කරන්න",
  "Recolor": "වර්ණ යළි සකසන්න",
  "snapbotTips1": "ඉක්මන් සෙවීම් ප්‍රතිඵල",
  "snapbotTips2": "ස්වාභාවික භාෂා සැකසුම",
  "snapbotTips3": "විශාල දත්ත විශ්ලේෂණය",
  "snapbotTips4": "AI බලගත් අල්ගොරිදම්",
  "snapbotInput1": "SnapBot සමඟ ආරම්භ කිරීමට මෙතැනට ටැප් කරන්න",
  "white": "සුදු",
  "blue": "නිල",
  "1 inch": "1 අඟල්",
  "2 inches": "2 අඟල්",
  "3 inches": "3 අඟල්",
  "landTips11": "අසමසම ඡායාරූප නිර්මාණය කරන්න &",
  "ChangeHairstyle": "කෙස් මුහුණු මායාව",
  "ChangeHairstyle_short": "ඔබ සිතන කෙස් මුහුණු නිර්මාණය කරන්න සහ උත්සාහ කරන්න",
  "ChangeHairstyle_content_1": "Snapai යෙදුම කෙස් හැඩ වෙනස් කිරීමේ විශේෂාංගයක් සපයයි, පරිශීලකයින්ට විවිධ කෙස් හැඩ තත්‍ය කාලීනව හෝ උඩුගත කළ ඡායාරූප මගින් උත්සාහ කිරීමට ඉඩ සලසයි. මෙම විශේෂාංගය AI තාක්ෂණය භාවිතා කර පරිශීලකගේ මුහුණේ විශේෂාංග විශ්ලේෂණය කර, ඔවුන්ගේ මුහුණේ හැඩයට ගැලපෙන කෙස් හැඩ පරිගණක උපදෙස් සපයයි. පරිශීලකයින්ට සුළු වෙනස්කම් සිට දැඩි හා නිරූපිත වෙනස්කම් දක්වා විවිධ රූප උත්සාහ කිරීමට හැකියාව ඇත, වාස්තු සැකසුමට පෙර දෘශ්‍යමය පූර්වදර්ශනයක් ලබා දේ. යෙදුම පරිශීලකයින්ට විවිධ කෙස් හැඩ සොයා බලන්න සහ සුදුසුම එකක් තෝරන්න පහසු සහ සතුටුදායක ක්‍රමයක් සපයයි.",
  "ChangeHairstyle_content_2": "පහත ඔබ කැමති කෙස් හැඩ තෝරන්න සහ ඔබේ ඡායාරූප එකතු කරන්න. ඔබට සුන්දර සහ පැහැදිලි රූපයක් ලැබේ.",
  "Result": "ප්‍රතිඵලය",
  "Original": "මුල්",
  "unsub_tip": "චන්දාව අවලංගු කිරීමට OFF 548 ට යවන්න",
  "sub_tip": "චන්දාව සඳහා, 'ON1' හෝ 'ON7' 548 ට යවන්න",
  "longHairEffects": "දිග කෙස් බලපෑම",
  "longHairEffects_tip": "දිග කෙස් බලපෑම උත්සාහ කරන්න, ස්වාභාවික සහ ආකර්ෂණීය කෙස් හැඩයක් ලබා දේ.\n" +
    "නිසි නිරතුරු සහ මිනී-අලංකාර\n" +
    "ස්වාභාවික දිග\n" +
    "ඕනෑම ඇඳුමකට සුදුසුයි, දිග කෙස් බලපෑම සමඟ දිනපතා හොඳම පෙනුම ලබා ගන්න!",
  "VIDEO": "වීඩියෝ",
  "image_video": "ඡායාරූපයෙන් වීඩියෝවට",
  "image_video_tip": "මෙම ක්‍රියාකාරිත්වය ස්ථිර් ඡායාරූපයක් 1–3 මිනිත්තු සජීවී සජීවී වීඩියෝවක් බවට පරිවර්තනය කරයි, ස්වභාවික මුහුණු ප්‍රකාශ සහ චලන එකතු කරමින් රූපය ජීවත් කරයි. පරිශීලකයින්ට ඉතිහාසයෙන් කලින් ජනනය කළ වීඩියෝ බලන්න හැකිය.",
  "word_video": "පෙළෙන් වීඩියෝවට",
  "word_video_tip": "ඔබ ලියන ලද පෙළ AI තාක්ෂණය භාවිතා කර සජීවී, ජීවිතාන්ත විඩියෝවක් බවට පරිවර්තනය කරයි, ඔබ කැමති ශෛලිය සහ ප්‍රකාශය පෙන්වයි. වීඩියෝව ජනනය කිරීමට 1–3 මිනිත්තු ගත විය හැක, කලින් නිර්මාණය කළ වීඩියෝ ඉතිහාසය තුළ විමර්ශනය කළ හැක.",
  "word_video_input": "ඔබ නිර්මාණය කිරීමට කැමති වීඩියෝවෙහි ශෛලිය සහ පෙනුම විස්තර කරන්න.",
  "image_video_input": "ඔබ නිර්මාණය කිරීමට කැමති ඡායාරූපයේ ශෛලිය සහ පෙනුම විස්තර කරන්න.",
  "aiDressUp": "AI ඇඳුම් ඇඳවීම",
  "aiDressUp_tip": "AI Dress Up සමඟ, ඔබේ පෙනුම වහාම වෙනස් කරන්න!\n" +
    "ඔබේ ඡායාරූප උඩුගත කර නොසැලසුම් ඇඳුම් උත්සාහ කරන්න—\n" +
    "සාම්ප්‍රදායික, ප්‍රාථමික හෝ නවීන. SnapAI ඔබේ ආකෘතියට\n" +
    "ස්වාභාවිකව ඇඳුම් අනුකූල කරයි, නව ශෛලී පෙරදැරීම් බලන්න\n" +
    "සහ විලාසිතාව පරීක්ෂා කිරීමෙන් සතුටු වන්න.",
  "aiDressUp_continue": "ඔබේ ඡායාරූප උඩුගත කර නොසැලසුම් ඇඳුම් උත්සාහ කරන්න—\nසාම්ප්‍රදායික, ප්‍රාථමික හෝ නවීන. SnapAI ඔබේ ආකෘතියට ස්වාභාවිකව ඇඳුම් අනුකූල කරයි, නව ශෛලී පෙරදැරීම් බලන්න සහ විලාසිතාව විඳින්න.",
  "singleheart": "ආදර බලපෑම",
  "singleheart_desc": "ඔබේ ආදරය බෙදාගන්න! ඔබේ වීඩියෝවට මදහස සහ රෝමන්තීය හදවත ආකාරයේ බලපෑම එක් කර, කෙනෙකුට ඔබ සැලකිල්ලෙන් සිටින බව පෙන්වන්න.",
  "aiVividScene": "ජීවිතවත් AI දෘශ්‍ය",
  "aiVividScene_desc": "නව AI දෘශ්‍ය නිර්මාණකරු සමඟ සෑම මනෝභාවයකට හා කාලසටහනකටම පරිපූර්ණ ඡායාරූපයක් ගන්න! ඔබට මුහුණ පැහැදිලි ඡායාරූපයක් එක්ක තිබේ නම්, විවිධ පසුබැසීම්, ශෛලී, වර්ණ සන්ධි තෝරා අසමසම, වර්ණවත් ඡායාරූප ජනනය කළ හැක. වියත්ම නිවෙස්, රාත්‍රී නගර පරිසරය, වැසි දින වීථියක් හෝ ඕනෑම කල්පිත සෙටින් එකකට ඔබ වහාම තැබිය හැක, සජීවීව සිටිය නොමැතිව.",
  "pic_size_limit": "ඡායාරූප 5MB ඉක්මවා නොයුතුය",
  "spin_tip_1": "ඔබේ අවස්ථාව මග නොහැරෙන්න!",
  "spin_tip_2": "Spin චක්‍රය දෛනික මෙහෙයුම් ප්‍රචාරණය සඳහා පමණක් ලබා දේ",
  "close": "වසන්න",
  "spin": "Spin කරන්න",
  "SpinChances": "Spin අවස්ථා",
  "date": "දිනය",
  "Prizes": "ප්‍රසාද",
  "nochance": "ඔබට අවශ්‍ය අවස්ථා නොමැත",
  "WinnerList": "ජයග්‍රාහක ලැයිස්තුව",
  "Congratulations": "බොහොම සුභ පැතුම්! ඔබ ජයග්‍රහණය කළා",
  "Confirm": "තහවුරු කරන්න",
  "spinTips2": "දෛනික නිදහස් Spin!",
  "spinTips3": "ඔබේ නිදහස් Lucky Spin ටෝකනය ලබා ඔබේ වාසිය උත්සාහ කරන්න!",
  "spinTips4": "මගේ ටෝකනය ගන්න",
  "No": "නැහැ",
  "not_win": "ක්‍රීඩා සඳහා ස්තුතියි. මීළඟ වරට වඩා හොඳ වාසියක්!",
  "win_tip": "ඔබේ සම්මානය ලබා ගැනීමට පහතින් ටැප් කරන්න",
  "Trending": "ප්‍රවණතා",
  "Face_Magic": "මුහුණ මායාව",
  "AI_Studio": "AI ස්ටුඩියෝ",
  "Home": "මුල් පිටුව",
  "unsubscribe": "චන්දාව අවලංගු කරන්න",
  "Back": "ආපසු",
  "Chances": "අවස්ථා",
  "Setting": "සැකසුම්",
  "Menu": "මෙනුව",
  "New": "අලුත්",
  "image_max_size": "ගොනු ප්‍රමාණය 5MB ඉක්මවා ඇත",
  "file_max_size": "ගොනු ප්‍රමාණය 1MB ඉක්මවා ඇත",
  "new_chat": "නව සංවාදය",
  "file": "ගොනුව",
  "image": "ඡායාරූපය",
  "invalid_image_format": "වලංගු නොවන ගොනු ආකෘතිය",
  "Shoot_same_video": "වීඩියෝව රූපගත කරන්න",
  otp_tips:"කරුණාකර otp කේතය ඇතුළත් කරන්න.",
  style:"ශෛලිය",
  error:"දෝෂය",
}



// WEBPACK FOOTER //
// ./src/assets/i18n/bur.js